<template></template>  
<script>
import { defineComponent } from "@vue/composition-api";
export default {
  data() {
    return {};
  },
};
</script>
